import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, isSecurityManager } from '@/utils/auth';
import Layout from './Layout';

export default function SecurityManagerRoute({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (!isSecurityManager()) {
    return <Navigate to="/" replace />;
  }

  return <Layout>{children}</Layout>;
}
